var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-units"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("ユニット一覧")])])],1),_c('Tools02UnitsUnitList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }